module.exports = __webpack_public_path__ + "static/media/videoPreview1.2f72bbd1.mp4";